type FeatureIconName = 'lock' | 'users' | 'grid' | 'mail' | 'code' | 'shield';

export function FeatureIcon({ name }: { name: FeatureIconName }) {
  const stroke = 'currentColor';
  const props = {
    viewBox: '0 0 16 16',
    fill: 'none',
    stroke,
    strokeWidth: 1.5,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    style: { color: 'var(--primary)' },
  };

  switch (name) {
    case 'lock':
      return (
        <svg {...props}>
          <rect x="3" y="7" width="10" height="8" rx="1.5" />
          <path d="M5 7V5a3 3 0 0 1 6 0v2" />
        </svg>
      );
    case 'users':
      return (
        <svg {...props}>
          <circle cx="8" cy="5" r="2.5" />
          <path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6" />
          <line x1="11" y1="5" x2="14" y2="5" />
          <line x1="11" y1="8" x2="14" y2="8" />
        </svg>
      );
    case 'grid':
      return (
        <svg {...props}>
          <rect x="2" y="2" width="5" height="5" rx="1" />
          <rect x="9" y="2" width="5" height="5" rx="1" />
          <rect x="2" y="9" width="5" height="5" rx="1" />
          <rect x="9" y="9" width="5" height="5" rx="1" />
        </svg>
      );
    case 'mail':
      return (
        <svg {...props}>
          <polyline points="2 4 8 8 14 4" />
          <rect x="2" y="3" width="12" height="10" rx="1.5" />
          <line x1="2" y1="8" x2="14" y2="8" />
        </svg>
      );
    case 'code':
      return (
        <svg {...props}>
          <polyline points="5 3 1 8 5 13" />
          <polyline points="11 3 15 8 11 13" />
          <line x1="9" y1="3" x2="7" y2="13" />
        </svg>
      );
    case 'shield':
      return (
        <svg {...props}>
          <path d="M8 2L2 5v4c0 3 2.7 5.3 6 6 3.3-.7 6-3 6-6V5L8 2z" />
        </svg>
      );
  }
}
